/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_3Inputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_3 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose File → Save As and save a new .xlsx copy. In the browser, this downloads a file. Check your downloads folder and the actual filename; a second save may produce a numbered copy.`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_3 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择 File → Save As，保存为新的 .xlsx 副本。在浏览器中，这会下载一个文件。检查下载文件夹和实际文件名，多次保存可能产生带编号的副本。`)
};

/**
* | output |
* | --- |
* | "Choose File → Save As and save a new .xlsx copy. In the browser, this downloads a file. Check your downloads folder and the actual filename; a second save ma..." |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_3 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_1_Steps_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_3(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_3(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_1_steps_3 as "gc.search_guides.gridcraft_excel_compatibility.sections.1.steps.3" }